import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { TextButton, Divider } from "@qgiv/core-donor";
import ConnectedStoreItemSummaryPrice from "./ConnectedStoreItemSummaryPrice";

const StoreCartSummary = ({
    baseUrl,
    changeAriaLabel,
    changeParticipantDetailsLinkLabel,
    removeAriaLabel,
    removeParticipantLinkLabel,
    displayChangeLink,
    displayDivider,
    Field_Data_Id,
    isCms,
    isVisible,
    productAttributes,
    productId,
    productName,
    formattedProductQuantity,
    renderStoreItemPrice = () => {},
    setProductModalOpen = () => {},
    storeCartIndex,
    removeRegistrationStoreCartItem = () => {},
    updateCurrentStoreCartItemIndex = () => {},
    updateOriginalStoreCartItemIndex = () => {},
}) => {
    const dispatch = useDispatch();

    const changeStoreCartInfoLink = (
        <>
            {isCms ? (
                <TextButton ariaLabel={changeParticipantDetailsLinkLabel}>
                    <strong>{changeParticipantDetailsLinkLabel}</strong>
                </TextButton>
            ) : (
                <Link
                    to={`${baseUrl}/form/store`}
                    id={`store-cart-${storeCartIndex}`}
                    onClick={() => {
                        dispatch(
                            updateCurrentStoreCartItemIndex(storeCartIndex),
                        );
                        dispatch(
                            updateOriginalStoreCartItemIndex(storeCartIndex),
                        );
                        dispatch(
                            setProductModalOpen({
                                productModalOpen: true,
                                currentProductId: productId,
                                modalAccessedFromStoreList: false,
                            }),
                        );
                    }}
                    aria-label={changeAriaLabel}
                >
                    <strong>{changeParticipantDetailsLinkLabel}</strong>
                </Link>
            )}
            {" • "}
        </>
    );
    const removeStoreCartLink = (
        <TextButton
            handleClick={(e) => {
                e.preventDefault();
                if (isCms) {
                    return;
                }
                dispatch(
                    removeRegistrationStoreCartItem({
                        index: null,
                        productId,
                        fieldDataId: Field_Data_Id,
                    }),
                );
            }}
            ariaLabel={removeAriaLabel}
        >
            <strong>{removeParticipantLinkLabel}</strong>
        </TextButton>
    );

    return isVisible ? (
        <>
            {/* eslint-disable-next-line tailwindcss/classnames-order */}
            <div className="grid grid--no-gutters">
                <div className="col col--8">
                    <small>
                        {`${productName} ${formattedProductQuantity}`}
                        {productAttributes.length > 0 &&
                            productAttributes.map((attribute, i) => {
                                if (attribute) {
                                    // eslint-disable-next-line react/no-array-index-key
                                    return <div key={i}>{attribute}</div>;
                                }
                                return null;
                            })}

                        <div>
                            {displayChangeLink ? changeStoreCartInfoLink : null}
                            {removeStoreCartLink}
                        </div>
                    </small>
                </div>
                <div className="col col--4 -text--right">
                    {isCms ? (
                        renderStoreItemPrice(productId, storeCartIndex)
                    ) : (
                        <ConnectedStoreItemSummaryPrice
                            productId={productId}
                            storeCartIndex={storeCartIndex}
                        />
                    )}
                </div>
            </div>
            {displayDivider && (
                <Divider classNames="registration-summary__divider" dashed />
            )}
        </>
    ) : null;
};

StoreCartSummary.propTypes = {
    baseUrl: PropTypes.string.isRequired,
    changeAriaLabel: PropTypes.string.isRequired,
    changeParticipantDetailsLinkLabel: PropTypes.string.isRequired,
    displayChangeLink: PropTypes.bool.isRequired,
    displayDivider: PropTypes.bool.isRequired,
    Field_Data_Id: PropTypes.string.isRequired,
    isCms: PropTypes.bool.isRequired,
    isVisible: PropTypes.bool.isRequired,
    productAttributes: PropTypes.arrayOf(PropTypes.string).isRequired,
    productId: PropTypes.number.isRequired,
    productName: PropTypes.string.isRequired,
    formattedProductQuantity: PropTypes.string.isRequired,
    removeAriaLabel: PropTypes.string.isRequired,
    removeParticipantLinkLabel: PropTypes.string.isRequired,
    removeRegistrationStoreCartItem: PropTypes.func.isRequired,
    // CMS rendering of ConnectedStoreItemSummaryPrice
    renderStoreItemPrice: PropTypes.func,
    setProductModalOpen: PropTypes.func.isRequired,
    storeCartIndex: PropTypes.number.isRequired,
    updateCurrentStoreCartItemIndex: PropTypes.func.isRequired,
    updateOriginalStoreCartItemIndex: PropTypes.func.isRequired,
};

export default StoreCartSummary;
